<template>
    <path fill-rule="evenodd" d="M15.864 0c.633 0 1.151.518 1.151 1.158 0 .64-.512 1.158-1.151 1.158H6.929c-2.546 0-4.62 2.073-4.62 4.618v19.132c0 2.545 2.074 4.618 4.62 4.618H26.07c2.546 0 4.62-2.073 4.62-4.618V17.06c0-.633.511-1.151 1.15-1.151.64 0 1.159.511 1.159 1.15v9.015C33 29.89 29.896 33 26.071 33H6.93C3.11 33 0 29.89 0 26.066V6.927C0 3.11 3.104 0 6.929 0zm15.78 0c.632 0 1.144.512 1.144 1.144v8.774c0 .632-.512 1.144-1.144 1.144-.625 0-1.138-.512-1.138-1.144v-6.02l-13.773 13.77c-.22.219-.512.332-.805.332-.293 0-.586-.113-.805-.333-.446-.445-.446-1.17 0-1.616l13.766-13.77h-6.021c-.632 0-1.138-.512-1.145-1.137 0-.632.513-1.144 1.145-1.144z"/>
</template>

<script>
export default {
    name: 'newWindowIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 33 33');
    }
}
</script>
